(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackOffersController', WinbackOffersController);

    WinbackOffersController.$inject = ['$state',];

    function WinbackOffersController($state) {
        // var vm = this;

        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'winbackOffers') {
                $state.go('winbackOffers.list');
            }
        }
    }
})();